<p *ngFor="let translationLanguage of translationLanguages">
  <a [routerLink]="[translationLanguage.languageCode]">{{ translationLanguage.languageName }}</a>
</p>
